import { Form, Formik } from "formik";
import React, { useState } from "react";
import MyTextInput from "../../app/common/form/MyTextInput";
import { Button, Header, Divider, Grid, Icon } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../app/stores/store";
import * as Yup from 'yup';
import ValidationErrors from "../errors/ValidationErrors";
import { useTranslation } from 'react-i18next';

export default observer(function RegisterForm() {
    const { userStore } = useStore();
    const { t } = useTranslation();
    const [socialLoading, setSocialLoading] = useState<string | null>(null);

    const handleSocialLogin = async (provider: 'google' | 'facebook') => {
        try {
            setSocialLoading(provider);
            await userStore.socialLogin(provider);
        } catch (error) {
            console.error(`${provider} login failed:`, error);
        } finally {
            setSocialLoading(null);
        }
    };

    return (
        <Formik
            initialValues={{ firstName: '', lastName: '', email: '', password: '', error: null }}
            onSubmit={(values, { setErrors }) =>
                userStore.register(values).catch(error => setErrors({ error }))
            }
            validationSchema={Yup.object({
                firstName: Yup.string().required(t('register.validation.firstNameRequired')),
                lastName: Yup.string().required(t('register.validation.lastNameRequired')),
                email: Yup.string().required(t('register.validation.emailRequired')).email(t('register.validation.emailInvalid')),
                password: Yup.string().required(t('register.validation.passwordRequired')),
            })}
        >
            {({ handleSubmit, isSubmitting, errors, isValid }) => (
                <Form className="ui form error" onSubmit={handleSubmit} autoComplete="off">
                    <Header as='h2' content={t('register.title')} color="teal" textAlign="center" />

                    {/* Social Login */}
                    <div style={{ marginBottom: '20px' }}>
                        <Grid columns={1} stackable>
                            <Grid.Column>
                                <Button
                                    type="button"
                                    fluid
                                    color="google plus"
                                    loading={socialLoading === 'google'}
                                    disabled={socialLoading !== null || isSubmitting}
                                    onClick={() => handleSocialLogin('google')}
                                >
                                    <Icon name="google" />
                                    {t('loginForm.socialLogin.google')}
                                </Button>
                            </Grid.Column>
                        </Grid>
                    </div>

                    <Divider horizontal>{t('loginForm.divider')}</Divider>

                    <MyTextInput name="firstName" placeholder={t('register.form.firstNamePlaceholder')} />
                    <MyTextInput name="lastName" placeholder={t('register.form.lastNamePlaceholder')} />
                    <MyTextInput name="email" placeholder={t('register.form.emailPlaceholder')} />
                    <MyTextInput name="password" placeholder={t('register.form.passwordPlaceholder')} type="password" />
                    <ValidationErrors errors={errors.error} />

                    <Button
                        disabled={!isValid || isSubmitting || socialLoading !== null}
                        loading={isSubmitting}
                        primary
                        content={t('register.form.submitButton')}
                        type="submit"
                        fluid
                    />
                </Form>
            )}
        </Formik>
    );
});